<!-- https://www.iconsdb.com/green-icons/check-mark-2-icon.html -->

<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '350px' }" [baseZIndex]="10000"></p-confirmDialog>

<!-- 		 				    -->
<!-- Section - Person Selector  -->
<!-- 			 	 			-->
<div class="show-hide-div">
	<div>
		<i
			class="pi"
			style="font-size: 24px"
			(click)="onToggleSelector()"
			[ngClass]="{
				'pi-chevron-circle-down': isHideSelector,
				'pi-chevron-circle-up': !isHideSelector
			}"
		></i>
	</div>

	<div style="margin-left: 10px">
		<label style="vertical-align: -webkit-baseline-middle">Select Person</label>
	</div>
</div>

<div [style.display]="isHideSelector == true ? 'none' : 'block'">
	<caass-personselector [AudienceID]="1" [CanSwitchAudience]="true" [ShowAllSchools]="false"></caass-personselector>
</div>

<!-- 		 			   -->
<!-- Section - Photo Edit  -->
<!-- 			 	 	   -->
<div class="show-hide-div">
	<div>
		<i
			class="pi"
			style="font-size: 24px"
			(click)="onTogglePhotoEdit()"
			[ngClass]="{
				'pi-chevron-circle-down': isHidePhotoEdit,
				'pi-chevron-circle-up': !isHidePhotoEdit
			}"
		></i>
	</div>

	<div style="margin-left: 10px">
		<label style="color: black; vertical-align: -webkit-baseline-middle">Capture Photo</label>
	</div>
	<div style="margin-left: 210px">
		<label style="color: #1c84c6; vertical-align: -webkit-baseline-middle">Name:</label>
	</div>
	<div style="margin-left: 5px">
		<label style="color: #ecaa1b; vertical-align: -webkit-baseline-middle">{{ PhotoStationData.Name }}</label>
	</div>
	<div style="margin-left: 20px">
		<label style="color: #1c84c6; vertical-align: -webkit-baseline-middle">Active CAASS Barcode:</label>
	</div>
	<div style="margin-left: 5px">
		<label style="color: #ecaa1b; vertical-align: -webkit-baseline-middle">{{ PhotoStationData.ActiveIDCardDesc }}</label>
	</div>
</div>

<div style="margin-bottom: 20px" [style.display]="isHidePhotoEdit == true ? 'none' : 'initial'">
	<div class="main-div">
		<!-- 		   -->
		<!-- CAM  BODY -->
		<!-- 		   -->
		<div class="main-div-cam">
			<div style="padding: 10px; background-color: #ebebeb">
				<button class="btn btn-info" style="margin-left: 0px" (click)="camTriggerSnapshot()">Capture</button>
				<!-- Image File Selector Button -->
				<label for="fileSelectImages" class="btn btn-info" style="margin-left: 5px">File Load</label>
				<input
					id="fileSelectImages"
					type="file"
					(change)="onFileLoad($event)"
					onclick="event.target.value=''"
					style="visibility: hidden; position: absolute"
					accept="image/*"
				/>
			</div>

			<div class="image-cam">
				<div id="div_cam" class="image-cam-div">
					<webcam
						[style.display]="isCamError == false ? 'block' : 'none'"
						[height]="300"
						[width]="300"
						[trigger]="camTriggerObservable"
						(initError)="camHandleInitError($event)"
						(imageCapture)="camHandleImage($event)"
					>
					</webcam>

					<div [style.display]="isCamError == true ? 'block' : 'none'">
						<label style="color: #990e0e">{{ CamErrorMessage }}</label>
					</div>
				</div>
			</div>

			<div class="image-cam-label">
				<label>WebCam</label>
			</div>
		</div>

		<!-- 		   -->
		<!-- EDIT BODY -->
		<!-- 		   -->
		<div class="main-div-edit">
			<div style="padding: 10px; background-color: #ebebeb">
				<button [ngClass]="this.isCustom == true ? 'btn btn-warning' : 'btn btn-primary'" style="margin-left: 0px" (click)="onCustom()">Custom</button>
				<button [ngClass]="this.isPortrait == true ? 'btn btn-warning' : 'btn btn-primary'" style="margin-left: 5px" (click)="onPortrait()">
					Portrait
				</button>
				<button [ngClass]="this.isLandscape == true ? 'btn btn-warning' : 'btn btn-primary'" style="margin-left: 5px" (click)="onLandscape()">
					Landscape
				</button>
				<button class="btn btn-primary" style="margin-left: 5px" (click)="onRotateCanvas()">Rotate</button>
				<!-- <button [ngClass]="this.cropperTransform.flipH == true ? 'btn btn-warning' : 'btn btn-primary'" style="margin-left: 5px;" (click)="onFlipImageH()">Flip H</button> -->
				<!-- <button [ngClass]="this.cropperTransform.flipV == true ? 'btn btn-warning' : 'btn btn-primary'" style="margin-left: 5px;" (click)="onFlipImageV()">Flip V</button> -->
				<button class="btn btn-primary" style="margin-left: 5px" (click)="onRestore()" [disabled]="isDisablePhotoSave == true">Restore</button>
				<button class="btn btn-primary" style="margin-left: 5px" (click)="onExport()">Export</button>
				<button class="btn btn-info" style="margin-left: 20px" (click)="onSave()" [disabled]="isDisablePhotoSave == true">Save</button>
			</div>

			<div class="image-editor">
				<div id="div_edit" class="image-editor-edit">
					<image-cropper
						class="cropper"
						format="jpeg"
						[aspectRatio]="cropperAspectRatio"
						[maintainAspectRatio]="cropperMaintainAspectRatio"
						[canvasRotation]="cropperCanvasRotation"
						[transform]="cropperTransform"
						[autoCrop]="true"
						[imageBase64]="cropperImageBase64"
						(imageCropped)="cropperImageCropped($event)"
						(imageLoaded)="cropperImageLoaded($event)"
						(cropperReady)="cropperReady()"
						(loadImageFailed)="cropperLoadImageFailed()"
					></image-cropper>
				</div>

				<div style="width: 35px; background-color: #ebebeb"></div>
				<!-- div Spacer -->

				<div id="div_view" class="image-editor-view">
					<img
						class="image-editor-view-img"
						[src]="cropperCroppedWorkImage"
						[style.visibility]="cropperCroppedWorkImage.length > 20 ? 'visible' : 'hidden'"
					/>
				</div>
			</div>

			<div class="image-editor-view-label">
				<div class="image-editor-view-label-div">
					<label>Edit</label>
				</div>
				<div class="image-editor-view-label-div">
					<label>Preview Save</label>
				</div>
			</div>

			<div style="padding-left: 10px; padding-top: 0px; padding-right: 10px; padding-bottom: 15px; background-color: #ebebeb">
				<!-- filterGrayscale -->
				<div class="filter-editor">
					<mat-slide-toggle class="myClass" [(ngModel)]="filterGrayscale" (change)="setGrayscaleValue($event)"></mat-slide-toggle>
					<div class="filter-editor" style="width: 75px"></div>
				</div>

				<div class="filter-editor">
					<label>Grayscale</label>
					<div class="filter-editor" style="width: 75px"></div>
				</div>

				<!-- filterBrightness -->
				<div class="filter-editor">
					<input type="range" min="-100" max="100" class="slider" [(ngModel)]="filterBrightness" (change)="setBrightnessValue($event)" />

					<div class="filter-editor" style="width: 75px">
						<button class="btn-xs btn-primary" (click)="onBrightnessReset()">Reset</button>
					</div>
				</div>

				<div class="filter-editor">
					<label>Brightness: {{ filterBrightness }}%</label>
					<div class="filter-editor" style="width: 75px"></div>
				</div>

				<!-- filterContrast -->
				<div class="filter-editor">
					<!-- Note: for realtime update of value, use:  (input)="setBrightnessValue($event)"	-->
					<input type="range" min="-100" max="100" class="slider" [(ngModel)]="filterContrast" (change)="setContrastValue($event)" />

					<div class="filter-editor" style="width: 75px">
						<button class="btn-xs btn-primary" (click)="onContrastReset()">Reset</button>
					</div>
				</div>

				<div class="filter-editor">
					<label>Contrast: {{ filterContrast }}%</label>
					<div class="filter-editor" style="width: 75px"></div>
				</div>

				<!-- filterAiProcessing -->
				<div class="ai-filter-editor" style="margin-top: 15px;">
					<div class="ai-filter-editor" style="width: 100%;">
						<div class="ai-filter-editor">
							<label>Background Color (BG)</label>
						</div>			

						<!-- COLOR PICKER (START) -->
						<input #AiColorPicker style="visibility: hidden; width: 0px;" 
							[(colorPicker)]="AiBackgroundColor" 	
							[(cpPresetColors)]="AiPresetColors"
							[(cpToggle)]="isAiShowColorPicker"
							[value]="AiBackgroundColor" 
							[style.background]="AiBackgroundColor" 
							[cpAlphaChannel]="'disabled'" 
							[cpOutputFormat] = "'hex'"
							[cpPosition]="'top'"
							[cpPositionOffset]="'50%'"
							[cpAddColorButtonText]="'Add Color'"
							[cpPresetLabel]="'School Preset Colors'"
							[cpPresetEmptyMessage]="'No School Preset Colors Added'"
							[cpCancelButton]="false"
							[cpOKButton]="false"
							[cpSaveClickOutside]="false"
							[cpAddColorButton]="true"
							[cpEyeDropper]="true"
							[cpMaxPresetColorsLength]="12"
							[cpExtraTemplate]="ColorPickerCustomTemplate"
							/>
						<ng-template #ColorPickerCustomTemplate>
							<div class="ai-filter-editor" style="background: #ffffff; justify-content: right; margin-bottom: 5px;">
								<button #AiColorPicker class="btn-xs btn-primary" style="margin-right: 5px; padding: 0px 10px 0px 10px;" (click)="onColorPickerOk()">OK</button>
								<button #AiColorPicker class="btn-xs btn-primary" style="margin-right: 5px; padding: 0px 5px 0px 5px;" (click)="onColorPickerCancel()">Cancel</button>
							</div>
						</ng-template>

						<button class="ai-colorpicker" style="margin-right: 10px;" [style.background]="AiBackgroundColor" (click)="onColorPickerOpen()" ></button>
						<!-- COLOR PICKER (END) -->

						<button class="btn-xs btn-primary" style="width: 140px;" (click)="onAiRemoveBackground()" [disabled]="isAiProcessing || isAiProcessed == true">Ai BG Color</button>
						
						<div class="ai-filter-editor" style="width: 30px;">
							<label>OR</label>
						</div>
						
						<button class="btn-xs btn-primary" style="width: 140px" (click)="onAiCreatePortrait()" [disabled]="isAiProcessing || isAiProcessed == true">Ai BG Color / Portrait</button>
						
						<div class="ai-filter-editor" style="width: 50px;">
							<img class="busy-ai-img" [style.display]="isAiProcessing == false ? 'none' : 'block'" src="assets/images/loading.gif" />
						</div>				
					</div>

					<div class="filter-editor" style="width: 75px">
						<button class="btn-xs btn-primary" (click)="onAIReset()" [disabled]="isAiProcessing || isAiProcessed == false" >Reset</button>
					</div>
				</div>

				
			</div>
		</div>
	</div>
</div>





<!-- 		 			   -->
<!-- Section - Signature   -->
<!-- 			 	 	   -->
<div class="show-hide-div">
	<div>
		<i
			class="pi"
			style="font-size: 24px"
			(click)="onToggleSignatureInfo()"
			[ngClass]="{
				'pi-chevron-circle-down': isHideSugnatureInfo,
				'pi-chevron-circle-up': !isHideSugnatureInfo
			}"
		></i>
	</div>

	<div style="margin-left: 10px">
		<label style="vertical-align: -webkit-baseline-middle">Capture Signature</label>
	</div>
</div>

<div class="sig-section"  [style.display]="isHideSugnatureInfo == true ? 'none' : 'block'">
	<div class="sig-body">

		<div class="sig-fixed-size-div1">

			<div class="sig-fixed-size-div2"> 
				<canvas #myCnv width="375" height="75"></canvas>		<!-- 375x75 -> Final Image Saved Is 500x100 -->
			</div>

			<div style="margin-top: 10px">
				<button class="btn btn-primary" (click)="onSign()">Capture Signature</button>
				<button class="btn btn-info" style="margin-left: 5px" (click)="onSaveSig()" [disabled]="isDisablePhotoSave == true">Save Signature</button>
			</div>
		</div>

		<div class="sig-spacer"></div>	<!-- Column Spacer -->

		<div class="sig-fixed-size-div1">
			<div class="sig-fixed-size-div2">
				<img [style.display]="isSigOnFile == false ? 'none' : 'block'" width="375" height="75" [src]="PhotoStationData.SignatureData" />
				<label style="margin-top: 25px" [style.display]="isSigOnFile == true ? 'none' : 'block'">No Signature on file in CAASS</label>
			</div>

			<div>
				<label style="margin-top: 15px" [style.display]="isSigOnFile == false ? 'none' : 'block'">Signature on file in CAASS</label>
			</div>			
		</div>
	</div>

	<div class="sig-download" [style.display]="user.personID != 0 ? 'none' : 'block'">
		<a href="https://notify.access411.com/SigWebDownload/sigweb.exe">TOPAZ SigWeb download (SU Only)</a>
	</div>	
</div>  

<!-- 		 			   -->
<!-- Section - Line Spacer -->
<!-- 			 	 	   -->
<div style="height: 20px; background-color: #ffffff;"></div>	<!-- Line Spacer -->


<!-- 		 			   -->
<!-- Section - Print       -->
<!-- 			 	 	   -->
<div class="print-div">
	<div class="print-button">
		<button class="btn btn-info" (click)="onPrint()" [disabled]="isDisablePhotoSave == true || QueueIsLocked == true">Print ID Card</button>
	</div>
	
	<div class="lockout-body" [style.display]="QueueIsLocked == true ? 'block' : 'none'">
		<label class="lockout-message">{{ LockoutMessage }}</label>
	</div>
</div>

<!-- 		 			   -->
<!-- Section - Line Spacer -->
<!-- 			 	 	   -->
<div style="height: 20px; background-color: #ffffff;"></div>	<!-- Line Spacer -->

<!-- 		 			   			-->
<!-- Section - Barcode/Person Info  -->
<!-- 			 	 	   			-->
<div class="show-hide-div">
	<div>
		<i
			class="pi"
			style="font-size: 24px"
			(click)="onTogglePersonInfo()"
			[ngClass]="{
				'pi-chevron-circle-down': isHidePersonInfo,
				'pi-chevron-circle-up': !isHidePersonInfo
			}"
		></i>
	</div>

	<div style="margin-left: 10px">
		<label style="vertical-align: -webkit-baseline-middle">Card / Person Information</label>
	</div>
</div>

<div class="barcode-table-main" [style.display]="isHidePersonInfo == true ? 'none' : 'block'">
	<!-- 					   -->
	<!-- Display Barcode Items -->
	<!-- 					   -->

	<!-- Note: resizableColumns breaks the multiline ability -->
	<p-table
		#mydt
		[value]="PhotoStationData.BarcodeItems"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[10, 25, 50]"
	>
		<ng-template pTemplate="header">
			<div class="barcode-table-toggle">
				<div class="p-d-flex" [style.display]="isShowEmbedded == false ? 'block' : 'none'">
					<button
						pButton
						style="width: 100px"
						label="Embedded ID"
						class="p-button-outlined"
						icon="pi pi-plus-circle"
						(click)="ontoggleEmbedded()"
					></button>
				</div>
				<div class="p-d-flex" [style.display]="isShowEmbedded == true ? 'block' : 'none'">
					<button
						pButton
						style="width: 100px"
						label="Embedded ID"
						class="p-button-outlined"
						icon="pi pi-minus-circle"
						(click)="ontoggleEmbedded()"
					></button>
				</div>

				<div class="p-d-flex" [style.display]="isShowExpire == false ? 'block' : 'none'" style="margin-left: 10px">
					<button
						pButton
						style="width: 100px"
						label="Expire Date"
						class="p-button-outlined"
						icon="pi pi-plus-circle"
						(click)="ontoggleExpire()"
					></button>
				</div>
				<div class="p-d-flex" [style.display]="isShowExpire == true ? 'block' : 'none'" style="margin-left: 10px">
					<button
						pButton
						style="width: 100px"
						label="Expire Date"
						class="p-button-outlined"
						icon="pi pi-minus-circle"
						(click)="ontoggleExpire()"
					></button>
				</div>
			</div>

			<tr style="height: 4rem">
				<th pSortableColumn="CAASSBarcode">Barcode<p-sortIcon field="CAASSBarcode"></p-sortIcon></th>
				<th pSortableColumn="UID">UID<p-sortIcon field="UID"></p-sortIcon></th>
				<th [style.display]="isShowEmbedded == true ? 'table-cell' : 'none'" pSortableColumn="MTAID">
					Embedded ID<p-sortIcon field="MTAID"></p-sortIcon>
				</th>
				<th pSortableColumn="CardName">Card Name<p-sortIcon field="CardName"></p-sortIcon></th>
				<th pSortableColumn="IDCardStockDesc">Card Stock<p-sortIcon field="IDCardStockDesc"></p-sortIcon></th>
				<th pSortableColumn="BarcodeStatusDesc">Card Status<p-sortIcon field="BarcodeStatusDesc"></p-sortIcon></th>
				<th pSortableColumn="IssueDate">Issue Date<p-sortIcon field="IssueDate"></p-sortIcon></th>
				<th [style.display]="isShowExpire == true ? 'table-cell' : 'none'" pSortableColumn="ExpirationDate">
					Expire Date<p-sortIcon field="ExpirationDate"></p-sortIcon>
				</th>
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-rBarcodeItem>
			<tr>
				<td>
					<div class="barcode-table-data1 barcode-table-black" style="font-weight: bold">
						{{ rBarcodeItem.CAASSBarcode }}
					</div>
				</td>

				<td>
					<div class="barcode-table-data1 barcode-table-black">
						{{ rBarcodeItem.UID }}
					</div>
				</td>

				<td [style.display]="isShowEmbedded == true ? 'table-cell' : 'none'">
					<div class="barcode-table-data1 barcode-table-black">
						{{ rBarcodeItem.MTAID }}
					</div>
				</td>

				<td>
					<div class="barcode-table-data2 barcode-table-black">
						{{ rBarcodeItem.CardName }}
					</div>
				</td>

				<td>
					<div class="barcode-table-data2 barcode-table-black">
						{{ rBarcodeItem.IDCardStockDesc }}
					</div>
				</td>

				<td>
					<div
						[ngClass]="{
							'barcode-table-data2 cgreen': rBarcodeItem.IDStatusID == 0,
							'barcode-table-data2 cred': rBarcodeItem.IDStatusID == 1 || rBarcodeItem.IDStatusID == 2 || rBarcodeItem.IDStatusID == 9,
							'barcode-table-data2 corange': rBarcodeItem.IDStatusID == 3 || rBarcodeItem.IDStatusID == 4 || rBarcodeItem.IDStatusID == 7,
							'barcode-table-data2 cblack':
								rBarcodeItem.IDStatusID == 5 || rBarcodeItem.IDStatusID == 6 || rBarcodeItem.IDStatusID == 8 || rBarcodeItem.IDStatusID > 9
						}"
					>
						{{ rBarcodeItem.BarcodeStatusDesc }}
					</div>
				</td>

				<td>
					<div>
						{{ rBarcodeItem.IssueDateDesc }}
					</div>
				</td>

				<td [style.display]="isShowExpire == true ? 'table-cell' : 'none'">
					<div>
						{{ rBarcodeItem.ExpirationDateDesc }}
					</div>
				</td>
			</tr>
		</ng-template>
	</p-table>

	<!-- 					  -->
	<!-- Display Student Data -->
	<!-- 					  -->
	<div class="PersonStudentData-main" [style.display]="PhotoStationData.IsStaff == false ? 'block' : 'none'">
		<div class="PersonData-col">
			<!-- COL1 -->
			<div style="width: 400px">
				<table>
					<tr>
						<td class="PersonData-title-tab">Student ID:</td>
						<td class="PersonData-data-tab">
							{{ PhotoStationData.StudentItems.StudentID }}
						</td>
					</tr>
					<tr>
						<td class="PersonData-title-tab">Name:</td>
						<td class="PersonData-data-tab">
							{{ PhotoStationData.StudentItems.FirstName }}
							{{ PhotoStationData.StudentItems.LastName }}
						</td>
					</tr>
					<tr>
						<td class="PersonData-title-tab">Address 1:</td>
						<td class="PersonData-data-tab">
							{{ PhotoStationData.StudentItems.Street1 }}
						</td>
					</tr>
					<tr>
						<td class="PersonData-title-tab">Address 2:</td>
						<td class="PersonData-data-tab">
							{{ PhotoStationData.StudentItems.Street2 }}
						</td>
					</tr>
					<tr>
						<td class="PersonData-title-tab">City, State zip:</td>
						<td class="PersonData-data-tab">
							{{ PhotoStationData.StudentItems.City }},
							{{ PhotoStationData.StudentItems.State }}
							{{ PhotoStationData.StudentItems.Zip }}
						</td>
					</tr>
					<tr>
						<td class="PersonData-title-tab">Home Phone:</td>
						<td class="PersonData-data-tab">
							{{ PhotoStationData.StudentItems.HomePhone }}
						</td>
					</tr>
					<tr>
						<td class="PersonData-title-tab">Work Phone:</td>
						<td class="PersonData-data-tab">
							{{ PhotoStationData.StudentItems.WorkPhone }}
						</td>
					</tr>
					<tr>
						<td class="PersonData-title-tab">E-mail:</td>
						<td class="PersonData-data-tab">
							{{ PhotoStationData.StudentItems.EMailAddress }}
						</td>
					</tr>
					<tr>
						<td class="PersonData-title-tab">Birth Date:</td>
						<td class="PersonData-data-tab">
							{{ PhotoStationData.StudentItems.DOB | date : "mediumDate" }}
						</td>
					</tr>
					<tr>
						<td class="PersonData-title-tab">Grade:</td>
						<td class="PersonData-data-tab">
							{{ PhotoStationData.StudentItems.Grade }}
						</td>
					</tr>
					<tr>
						<td class="PersonData-title-tab">Gender:</td>
						<td class="PersonData-data-tab">
							{{ PhotoStationData.StudentItems.Gender }}
						</td>
					</tr>
					<tr>
						<td class="PersonData-title-tab">Ethnicity:</td>
						<td class="PersonData-data-tab">
							{{ PhotoStationData.StudentItems.EthnicityDesc }}
						</td>
					</tr>
					<tr [style.display]="PhotoStationData.StudentItems.IsShowMTARider == true ? 'table-row' : 'none'">
						<td class="PersonData-title-tab">{{ PhotoStationData.StudentItems.IsMTARiderDesc }}:</td>
						<td class="PersonData-data-tab">
							{{ PhotoStationData.StudentItems.IsMTARider ? "Yes" : "No" }}
						</td>
					</tr>
					<tr [style.display]="PhotoStationData.StudentItems.IsShowMTAOverride == true ? 'table-row' : 'none'">
						<td class="PersonData-title-tab">{{ PhotoStationData.StudentItems.IsMTAOverrideDesc }}:</td>
						<td class="PersonData-data-tab">
							{{ PhotoStationData.StudentItems.IsMTAOverride ? "Yes" : "No" }}
						</td>
					</tr>
				</table>
			</div>

			<!-- COL2 -->
			<div style="width: 400px">
				<tr>
					<td class="PersonData-title-tab">{{ PhotoStationData.StudentItems.SSNlabel }}:</td>
					<td class="PersonData-data-tab">
						{{ PhotoStationData.StudentItems.SSN }}
					</td>
				</tr>
				<tr>
					<td class="PersonData-title-tab">Enrollment Date:</td>
					<td class="PersonData-data-tab">
						{{ PhotoStationData.StudentItems.EnrollmentDate | date : "mediumDate" }}
					</td>
				</tr>
				<tr>
					<td class="PersonData-title-tab">Withdrawl Date:</td>
					<td class="PersonData-data-tab">
						{{ PhotoStationData.StudentItems.WithdrawlDate | date : "mediumDate" }}
					</td>
				</tr>
				<tr>
					<td class="PersonData-title-tab">Homeroom:</td>
					<td class="PersonData-data-tab">
						{{ PhotoStationData.StudentItems.Homeroom }}
					</td>
				</tr>
				<tr>
					<td class="PersonData-title-tab">Academy:</td>
					<td class="PersonData-data-tab">
						{{ PhotoStationData.StudentItems.Academy }}
					</td>
				</tr>
				<tr>
					<td class="PersonData-title-tab">Advisor:</td>
					<td class="PersonData-data-tab">
						{{ PhotoStationData.StudentItems.Advisor }}
					</td>
				</tr>
				<tr>
					<td class="PersonData-title-tab">Bus Number:</td>
					<td class="PersonData-data-tab">
						{{ PhotoStationData.StudentItems.BusNumber }}
					</td>
				</tr>
				<tr>
					<td class="PersonData-title-tab">Intensity Level:</td>
					<td class="PersonData-data-tab">
						{{ PhotoStationData.StudentItems.IntensityLevel }}
					</td>
				</tr>
				<tr>
					<td class="PersonData-title-tab">Meal Subsidy Type:</td>
					<td class="PersonData-data-tab">
						{{ PhotoStationData.StudentItems.LunchType }}
					</td>
				</tr>
				<tr>
					<td class="PersonData-title-tab">Fines Owed:</td>
					<td class="PersonData-data-tab">
						{{ PhotoStationData.StudentItems.FineBalance | currency : "USD" }}
					</td>
				</tr>
				<tr>
					<td class="PersonData-title-tab">Meals Owed:</td>
					<td class="PersonData-data-tab">
						{{ PhotoStationData.StudentItems.MealBalance | currency : "USD" }}
					</td>
				</tr>
				<tr>
					<td class="PersonData-title-tab">Active:</td>
					<td class="PersonData-data-tab">
						{{ PhotoStationData.StudentItems.Active ? "Yes" : "No" }}
					</td>
				</tr>
			</div>
		</div>
	</div>

	<!-- 					-->
	<!-- Display Staff Data -->
	<!-- 					-->
	<div class="PersonStaffData-main" [style.display]="PhotoStationData.IsStaff == true ? 'block' : 'none'">
		<div class="PersonData-col">
			<!-- COL1 -->
			<div style="width: 400px">
				<table>
					<tr>
						<td class="PersonData-title-tab">Staff ID:</td>
						<td class="PersonData-data-tab">
							{{ PhotoStationData.StaffItems.StaffID }}
						</td>
					</tr>
					<tr>
						<td class="PersonData-title-tab">Name:</td>
						<td class="PersonData-data-tab">
							{{ PhotoStationData.StaffItems.FirstName }}
							{{ PhotoStationData.StaffItems.LastName }}
						</td>
					</tr>
					<tr>
						<td class="PersonData-title-tab">Address 1:</td>
						<td class="PersonData-data-tab">
							{{ PhotoStationData.StaffItems.Street1 }}
						</td>
					</tr>
					<tr>
						<td class="PersonData-title-tab">Address 2:</td>
						<td class="PersonData-data-tab">
							{{ PhotoStationData.StaffItems.Street2 }}
						</td>
					</tr>
					<tr>
						<td class="PersonData-title-tab">City, State zip:</td>
						<td class="PersonData-data-tab">
							{{ PhotoStationData.StaffItems.City }},
							{{ PhotoStationData.StaffItems.State }}
							{{ PhotoStationData.StaffItems.Zip }}
						</td>
					</tr>
					<tr>
						<td class="PersonData-title-tab">Birth Date:</td>
						<td class="PersonData-data-tab">
							{{ PhotoStationData.StaffItems.DOB | date : "mediumDate" }}
						</td>
					</tr>
					<tr>
						<td class="PersonData-title-tab">Gender:</td>
						<td class="PersonData-data-tab">
							{{ PhotoStationData.StaffItems.Gender }}
						</td>
					</tr>
					<tr>
						<td class="PersonData-title-tab">Ethnicity:</td>
						<td class="PersonData-data-tab">
							{{ PhotoStationData.StaffItems.EthnicityDesc }}
						</td>
					</tr>
					<tr>
						<td class="PersonData-title-tab">E-mail:</td>
						<td class="PersonData-data-tab">
							{{ PhotoStationData.StaffItems.EMailAddress }}
						</td>
					</tr>
				</table>
			</div>

			<!-- COL2 -->
			<div style="width: 400px">
				<tr>
					<td class="PersonData-title-tab">{{ PhotoStationData.StaffItems.SSNlabel }}:</td>
					<td class="PersonData-data-tab">
						{{ PhotoStationData.StaffItems.SSN }}
					</td>
				</tr>
				<tr>
					<td class="PersonData-title-tab">Staff Title:</td>
					<td class="PersonData-data-tab">
						{{ PhotoStationData.StaffItems.StaffTitle }}
					</td>
				</tr>
				<tr>
					<td class="PersonData-title-tab">Staff Type:</td>
					<td class="PersonData-data-tab">
						{{ PhotoStationData.StaffItems.PersonTypeDesc }}
					</td>
				</tr>
				<tr>
					<td class="PersonData-title-tab">Home Phone:</td>
					<td class="PersonData-data-tab">
						{{ PhotoStationData.StaffItems.HomePhone }}
					</td>
				</tr>
				<tr>
					<td class="PersonData-title-tab">Work Phone:</td>
					<td class="PersonData-data-tab">
						{{ PhotoStationData.StaffItems.WorkPhone }}
					</td>
				</tr>
				<tr>
					<td class="PersonData-title-tab">Cell Phone:</td>
					<td class="PersonData-data-tab">
						{{ PhotoStationData.StaffItems.CellPhone }}
					</td>
				</tr>
				<tr>
					<td class="PersonData-title-tab">Fax:</td>
					<td class="PersonData-data-tab">
						{{ PhotoStationData.StaffItems.FaxNumber }}
					</td>
				</tr>
				<tr>
					<td class="PersonData-title-tab">Active:</td>
					<td class="PersonData-data-tab">
						{{ PhotoStationData.StaffItems.Active ? "Yes" : "No" }}
					</td>
				</tr>
			</div>
		</div>
	</div>
</div>
